import React from 'react';

export default function BlogSkeleton({ article = false, count = 6 }) {
  return (
    <div role="status" aria-label={article ? 'Loading article' : 'Loading articles'} aria-busy="true">
      {article ? <>
        <div className="blog-hero blog-skeleton-hero" aria-hidden="true">
          <div className="blog-hero-inner">
            <div className="blog-skeleton-line blog-skeleton-short" />
            <div className="blog-skeleton-line blog-skeleton-title" />
            <div className="blog-skeleton-line blog-skeleton-title" />
            <div className="blog-skeleton-line" />
          </div>
        </div>
        <div className="blog-skeleton-body" aria-hidden="true">
          {Array.from({ length: 7 }, (_, i) => <div key={i} className="blog-skeleton-line" />)}
        </div>
      </> : <div className="blog-related-grid" aria-hidden="true">
        {Array.from({ length: count }, (_, i) => <div className="blog-related-card" key={i}>
          <div className="blog-skeleton-image" />
          <div className="blog-related-card-body">
            <div className="blog-skeleton-line blog-skeleton-short" />
            <div className="blog-skeleton-line blog-skeleton-title" />
            <div className="blog-skeleton-line" />
            <div className="blog-skeleton-line" />
          </div>
        </div>)}
      </div>}
    </div>
  );
}
